import { defineComponent as _defineComponent } from 'vue'
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowPersonContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { useSearchSuggesterStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCreditName',
  props: {
    credit: { default: () => ({
			id: 0,
			name: '',
			role: '',
			profilePath: '',
		}) }
  },
  setup(__props: any) {

const props = __props as { credit: {
			id?: number;
			name?: string;
			role?: string;
			profilePath?: string;
		} };



const { goToSearch } = useSearchSuggesterStore();

function clicked(searchString: { searchString: string | undefined; personId: number | undefined }) {
	if (!props.credit?.profilePath) goToSearch(searchString);

	const personContext = new SnowplowPersonContext(searchString.personId ?? 0, searchString.searchString ?? '');
	TrackingHelper.trackEvent(
		'persons_credit_name',
		{
			action: 'clicked',
			label: props.credit?.role,
			property: searchString.personId + '',
		},
		[personContext]
	);
}

return { __sfc: true,props, goToSearch, clicked }
}

})